Ext.define('SA.ExportWidget', {
    alias: 'widget.export-widget',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-export-widget',
    width: 304,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-export-widget-body',

            items: [
                {
                    xtype: 'load-mask',
                    itemId: 'loadMask',
                    spinnerSize: 'small'
                }, {
                    xtype: 'simple-container',
                    hidden: true,
                    itemId: 'limitMessageTarget'
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-export-widget-field-row',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-export-widget-field-label',
                            html: 'File format:',
                            width: 73
                        }, {
                            xtype: 'sa-radio-group',
                            cls: 'sa-export-widget-file-format-radio-group',
                            disabled: true,
                            hidden: true,
                            itemId: 'tableFormats',

                            items: [
                                {boxLabel: 'Excel', value: 'xlsx', checked: true},
                                {boxLabel: 'CSV', value: 'csv'},
                                {boxLabel: 'DBF', value: 'zip'}
                            ]
                        }, {
                            xtype: 'sa-radio-group',
                            cls: 'sa-export-widget-file-format-radio-group',
                            disabled: true,
                            hidden: true,
                            itemId: 'chartFormats',

                            items: [
                                {boxLabel: 'PNG', value: 'png', checked: true},
                                {boxLabel: 'JPEG', value: 'jpeg'},
                                {boxLabel: 'SVG', value: 'svg'},
                                {boxLabel: 'PDF', value: 'pdf'}
                            ]
                        }
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-export-widget-field-row',
                    margin: '17 0 0 0',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-export-widget-field-label',
                            html: 'Export to:',
                            width: 73
                        }, {
                            xtype: 'sa-toggle-switch',
                            checked: true,
                            cls: 'sa-export-widget-email-or-save-toggle-switch',
                            disabled: true,
                            itemId: 'toggle',
                            leftText: 'Email',
                            rightText: 'Save to computer'
                        }
                    ]
                }, {
                    xtype: 'container',
                    hidden: true,
                    itemId: 'emailSection',

                    defaults: {
                        labelAlign: 'top',
                        labelCls: 'sa-export-widget-field-label',
                        labelClsExtra: 'sa-export-widget-field-label-top',
                        margin: '17 0 0 0',
                        width: '100%'
                    },

                    items: [
                        {
                            xtype: 'sa-textfield',
                            allowBlank: false,
                            fieldLabel: 'Email address:',
                            itemId: 'emailAddress',
                            msgTarget: 'none',
                            vtype: 'email'
                        }, {
                            xtype: 'textarea',
                            fieldLabel: 'Message (optional):',
                            itemId: 'emailMessage'
                        }
                    ]
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-export-widget-footer',

            items: [
                {
                    xtype: 'sa-button',
                    autoEl: {tag: 'button'},
                    text: 'Export',
                    disabled: true,
                    itemId: 'exportBtn',
                    ui: 'primary',
                    width: 118
                }, {
                    xtype: 'sa-button',
                    autoEl: {tag: 'button'},
                    text: 'Cancel',
                    itemId: 'cancelBtn',
                    width: 118
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.loadMask = this.down('#loadMask');
        this.limitMessageTarget = this.down('#limitMessageTarget');
        this.tableFormats = this.down('#tableFormats');
        this.chartFormats = this.down('#chartFormats');
        this.toggle = this.down('#toggle');
        this.emailSection = this.down('#emailSection');
        this.emailAddress = this.down('#emailAddress');
        this.emailMessage = this.down('#emailMessage');
        this.exportBtn = this.down('#exportBtn');
        this.cancelBtn = this.down('#cancelBtn');

        this.formats = this.config.isTable() ? this.tableFormats : this.chartFormats;
        this.formats.show();

        this.emailAddress.setValue(SA.User.getEmailAddress());
    },

    downloadSelected() {
        return this.toggle.isChecked();
    },

    initEvents() {
        this.callParent();

        this.toggle.on('change', this.refresh, this);
        this.emailAddress.on('blur', this.refresh, this);
        this.emailAddress.on('change', this.refresh, this);
        this.exportBtn.on('click', this.onExportClick, this);
        this.cancelBtn.on('click', this.onCancelClick, this);

        this.config.onLimitCheckReady(this.onLimitCheckReady.bind(this));
    },

    onCancelClick() {
        this.fireEvent('click:cancel');
    },

    onLimitCheckReady({canExport, messageOrNull}) {
        if (this.isDestroyed) {
            return;
        }

        this.loadMask.hide();

        if (canExport) {
            this.formats.enableExcept(this.config.getUnsupportedFormats());
            this.toggle.enable();
            this.exportBtn.enable();
            this.formats.el.query('.sa-radio-button')[0].focus();
        }
        else if (messageOrNull !== null) {
            this.limitMessageTarget.add(messageOrNull);
            this.limitMessageTarget.show();

            this.updateLayout();
        }
    },

    onExportClick() {
        var isDownload = this.downloadSelected(),
            extension = this.formats.getValue(),
            emailParams = {address: this.emailAddress.getValue(), message: this.emailMessage.getValue()},
            params = Object.assign({isDownload, extension, emailParams}, this.config.getParams());

        SA.Exports.export(params);

        this.fireEvent('click:export');
    },

    refresh() {
        var downloadSelected = this.downloadSelected();

        this.emailSection.setVisible(!downloadSelected);
        this.exportBtn.setEnabled(downloadSelected || this.emailAddress.isValid());

        this.updateLayout();
    }
});
